module.exports = __webpack_public_path__ + "static/media/github.04ac53bc.svg";